import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { Component as ComponentContainer } from '@styles/layout';
import { SearchResultsPadding } from '@styles/search-layout';
import { TextComponent } from '@model/content';
import { useI18NextContext } from '@components/hooks';
import { americanize } from '@util/string';
import { ConditionalWrapper } from '@util/common';

interface TextProps extends ThemeProps {
  alignment?: string;
}
const Title: any = styled.h1(({ theme, alignment }: TextProps) => ({
  ...(theme.custom.typography.h2 as any),
  ...(alignment && { textAlign: alignment }),
  marginBottom: 10
}));

export const TitleContainer = ({ value, alignment, destination, data }: TextComponent) => {
  const t = useI18NextContext();

  const textAlign = alignment && americanize(alignment);
  const text = /\{\{/.test(value) ? t(value, { destination: destination?.display }) : value;
  const fullWidth = data?.fullWidth;

  return (
    <ComponentContainer isEdgeToEdge={fullWidth}>
      <ConditionalWrapper
        condition={fullWidth}
        wrapper={(children) => <SearchResultsPadding>{children}</SearchResultsPadding>}
      >
        <Title alignment={textAlign}>{text}</Title>
      </ConditionalWrapper>
    </ComponentContainer>
  );
};
